import Vue from 'vue';
import Buefy from 'buefy';
import Axios from 'axios';
import VueAxios from 'vue-axios';
import Moment from 'moment';
import VueMoment from 'vue-moment';
import VueSweetalert2 from 'vue-sweetalert2';
import App from './App.vue';
import router from './router';
import store from './store';

Vue.config.productionTip = false;

Vue.use(Buefy, {
  defaultDateFormatter(date) {
    return Moment(date).format('DD MMM YYYY');
  },
  defaultDateParser(date) {
    return Moment(date).format('YYYY-MM-DD');
  },
  defaultIconPack: 'fas',
});

Axios.defaults.baseURL = process.env.VUE_APP_API_URL;
Vue.use(VueAxios, Axios);

Vue.use(VueMoment);

Vue.use(VueSweetalert2);

router.beforeEach((to, from, next) => {
  const isLoggedIn = store.getters['auth/isLoggedIn'];

  switch (to.name) {
    case 'login':
      if (!isLoggedIn) {
        next();
      } else {
        next({ name: 'home' });
      }
      break;
    default:
      if (!isLoggedIn) {
        store.dispatch('auth/logout').finally(() => {
          next({ name: 'login' });
        });
      } else {
        next();
      }
      break;
  }
});

Vue.prototype.$websiteUrl = process.env.VUE_APP_WEBSITE_URL;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
